/**********************************************************************************************************
*   BASE IMPORTS
**********************************************************************************************************/
import { useEffect, useRef } from 'react'
import { Field, Form, Formik, FormikProps } from 'formik'
import * as Yup from 'yup'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Form as NXUIForm } from '@nexigendigital/nxui'
import { useSupportRequestMutation } from 'api/support'

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
import styled from 'styled-components'

const Support = {
    Form: styled(Form)`
        position: relative;
        width: 100%;
        height: 100%;
    `,
    Body: styled.div`
        padding: 20px 20px 0px;
    `
}

/**********************************************************************************************************
*   COMPONENT START
**********************************************************************************************************/
export default function SupportForm() {
    const supportFormRef = useRef<FormikProps<{ subject: string, message: string, type: string }>>(null)
    const [supportRequest, { isSuccess: supportRequestSuccess, isError: supportRequestError, data: supportRequestData }] = useSupportRequestMutation()

    useEffect(() => {
        if (((supportRequestSuccess && supportRequestData?.login?.error) || supportRequestError) && supportFormRef.current) {
            supportFormRef.current.setSubmitting(false)
        }
    }, [supportRequestSuccess, supportRequestData])

    return (
        <Formik
            innerRef={supportFormRef}
            initialValues={{
                subject: '',
                message: '',
                type: 'tech'
            }}
            validationSchema={Yup.object({
                subject: Yup.string().required('Required'),
                message: Yup.string().required('Required'),
                type: Yup.string().required('Required'),
                attachments: Yup.array()
            })}
            onSubmit={(form) => {
                supportRequest(form)
            }}
        >
            {({ isSubmitting }) => {
                return (
                    <Support.Form>
                        <Field
                            label={'Support Type'}
                            name={'type'}
                            type={'select'}
                            disabled={isSubmitting}
                            list={[
                                { value: 'tech', label: 'Technical Support' },
                                { value: 'accounts', label: 'Accounts' },
                                { value: 'billing', label: 'Billing' },
                                { value: 'sales', label: 'Sales' },
                                { value: 'customercare', label: 'Customer Care' }
                            ]}
                            component={NXUIForm.SelectField}
                        />
                        <Field
                            label={'Subject'}
                            name={'subject'}
                            type={'select'}
                            disabled={isSubmitting}
                            component={NXUIForm.InputField}
                        />
                        <Field
                            label={'How can we help you?'}
                            name={'message'}
                            type={'textarea'}
                            disabled={isSubmitting}
                            component={NXUIForm.TextAreaField}
                        />
                        <Field
                            label={'Attachments'}
                            name={'attachments'}
                            disabled={isSubmitting}
                            component={NXUIForm.Upload}
                        />
                    </Support.Form>
                )
            }}
        </Formik>
    )
}
